import { render, staticRenderFns } from "./RelatedUserComponent.vue?vue&type=template&id=0f67773c&scoped=true&"
import script from "./RelatedUserComponent.vue?vue&type=script&lang=js&"
export * from "./RelatedUserComponent.vue?vue&type=script&lang=js&"
import style0 from "./RelatedUserComponent.vue?vue&type=style&index=0&id=0f67773c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f67773c",
  null
  
)

export default component.exports